import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ComponentDataDestService } from '../../component-data-dest.service';
import { environment } from '../../../../environment/environment';
import {
  ProfileEpWizardPutPayload,
  ProfileEpWizardPutResultDTO,
} from '../../../../dto/educational-path/profile-ep-wizard.dto';
import { UserService } from '../../../user/user.service';

function normalizeDate(value: string | undefined | null): string | undefined {
  if (value === undefined || value === null || value === '') {
    return undefined;
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value + 'T00:00:00.000Z';
  }
  return value;
}

export function profile_user_ep_assign(
  componentDataDestService: ComponentDataDestService,
  data: ProfileEpWizardPutPayload
): Observable<ProfileEpWizardPutResultDTO> {
  const userUuid = data.userUuid;
  if (!userUuid) {
    return throwError(() => new Error('userUuid is required'));
  }

  if (!data.assignments?.length) {
    return throwError(() => new Error('At least one assignment is required'));
  }

  const body = {
    user: {
      requirement_started_at: normalizeDate(data.requirement_started_at),
      maintenance_started_at: normalizeDate(data.maintenance_started_at),
      assignments: data.assignments.map((a) => ({
        path_guid: a.path_guid,
        version_id: a.version_id,
      })),
    },
  };

  const userService = componentDataDestService.injector.get(UserService);

  return componentDataDestService.http
    .put<ProfileEpWizardPutResultDTO>(
      `${environment.apiUrl}/users/${userUuid}/educational-paths`,
      body,
      { withCredentials: true }
    )
    .pipe(
      tap(() => {
        userService.getUserByUuid(userUuid).subscribe({
          error: () => undefined,
        });
      })
    );
}
